import React from 'react';
import { BsInstagram } from 'react-icons/bs';
import {AiFillYoutube , AiFillLinkedin} from 'react-icons/ai';

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href="https://www.linkedin.com/in/nishad-ahamed-7911a1175/" target="_blank" rel="noopener noreferrer">
      <AiFillLinkedin />
      </a>
    </div>
    <div>
      <a href="https://www.youtube.com/channel/UCaincUQzdJA8pLVEKzqb-rQ" target="_blank" rel="noopener noreferrer">
      <AiFillYoutube />
      </a>
    </div>
    <div>
      <a href="https://www.instagram.com/ahmd_nish/" target="_blank" rel="noopener noreferrer">
      <BsInstagram />
      </a>
    </div>
  </div>
);

export default SocialMedia;